import cx from 'classnames';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

// components
import EmptyTable from './EmptyTable';


const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  contestTitle: string;
  includeCountyRundown?: boolean;
  isShowcaseRace?: boolean;
  renderParty: any;
  renderCandidate: any;
  embedType: string;
  broadcastHeaderImage: string;
  activeContestId: string;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      isShowcaseRace,
      renderParty,
    } = this.props;

    const onePrimary = contest.length == 1;

    let onePrimaryParty; 

    if (onePrimary) {
      onePrimaryParty = contest[0].party
    }

    const rowClass = cx({
      seat__races: !isShowcaseRace,
      seat__highlight_races: isShowcaseRace,
    });

    return (
      <div class="seat">
        {!isShowcaseRace && (
              <h3 class="seat__title">
                <span>{contestTitle}</span>
              </h3>
            )}
        <div class={rowClass}>
          {onePrimary && onePrimaryParty == 'Republican' && !isShowcaseRace && (
            <EmptyTable party={'Democrat'}/>       )}
          {!isShowcaseRace &&
            contest.map((party: any, index) => renderParty(party, index))}

          {isShowcaseRace && renderParty(contest)}
          {onePrimary && onePrimaryParty == 'Democrat' && !isShowcaseRace && (
            <EmptyTable party={'Republican'}/>       )}
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
};

export default Contest;
